var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRound3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 32.5,
    fill: "#A098AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 9.99994C36 9.99994 40.9799 8.99994 44.5 8.99994C48.0201 8.99994 53 9.99994 53 9.99994",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6372 67.7565C17.6372 67.7565 14.4824 63.7757 12.882 60.6405C11.2815 57.5052 9.90807 52.6151 9.90807 52.6151",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2986 55.4622C78.2986 55.4622 76.5235 60.2212 74.6679 63.2125C72.8124 66.2039 69.3376 69.9086 69.3376 69.9086",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound3);
export default __webpack_public_path__ + "static/media/round3.f6dade76140d0b2df8160603297f4478.svg";
export { ForwardRef as ReactComponent };